import {Component, OnInit} from "@angular/core";
import {CampagneDto, IParameterWebServiceClient, ParameterDTO} from "../../resources/auth/resources.auth";

@Component({
    selector: 'message-notification-component',
    templateUrl: './message-notification-component.html',
    styleUrls: ['./message-notification-component.scss']
})
export class MessageNotificationComponent implements OnInit {

    message: string | null | undefined;
    parameterDTO: ParameterDTO = new ParameterDTO();

    constructor(private parameterWebService: IParameterWebServiceClient) {
    }

    async ngOnInit() {
        this.parameterDTO = await this.parameterWebService.getMessageNotification().toPromise();
        this.message = this.parameterDTO.stringValue;
    }

}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/components/message-notification/message-notification-component.ts